import { createSlice } from "@reduxjs/toolkit";
import ShopifyClient from "shopify/client";
import { allMeals } from "utils/constants";

const initialState = {
	isClient: false,
	hasOfferBar: false,
	stickyATCShown: false,
	shopifyClient: new ShopifyClient(),
	view: allMeals,
};

const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		setGlobalData: (state, action) => {
			if (state.isClient) return;
			Object.assign(state, action.payload);
			state.isClient = true;
		},
		setHasOfferBar: (state, action) => {
			state.hasOfferBar = action.payload;
		},
		setStickyATCVisible: (state, action) => {
			state.stickyATCShown = action.payload;
		},
		setView: (state, action) => {
			state.view = action.payload;
		},
	},
});

export const {
	setGlobalData,
	setHasOfferBar,
	setStickyATCVisible,
	setView,
} = globalSlice.actions;

export default globalSlice.reducer;
